import { CustomerType } from '../../../shared/types';
import { MiraCustomerData } from '../../../shared/types/customer';
import { isCustomerBlocked } from './isCustomerBlocked';

/*
 * Order: Company chains, Customers, Prospects, Blocked customers
 */
export const sortCustomersByType = (
  a: MiraCustomerData,
  b: MiraCustomerData,
) => {
  const getPriority = (customer: MiraCustomerData): number => {
    if (isCustomerBlocked(customer)) return 3;
    if (customer.type === CustomerType.COMPANY_CHAIN) return 0;
    if (customer.type === CustomerType.MIRA) return 1;
    if (customer.type === CustomerType.PROSPECT) return 2;
    return 4; // fallback for unknown type
  };

  return getPriority(a) - getPriority(b);
};
